<template>
  <div class="pc-basket__top">
    <a v-if="isCloudStatusOpen && !isShopClosed"
      @click="show"
      class="pc-basket__top-basket cursor--pointer">
      {{ $t('configurator.labels.basket') }}: {{ $filters.formatMoney(basket.total_gross) }} <span v-if="articleCount > 0">({{ articleCount }} {{ (articleCount === 1) ? $t('configurator.labels.article') : $t('configurator.labels.articles') }})</span>
    </a>
    <a href="#" @click="$i18n.locale = 'de'" :class="{'active': !inEnglish}">
      <img class="flag" src="/images/de.svg" alt=""/>
    </a>
    <a href="#" @click="$i18n.locale = 'en'" :class="{'active': inEnglish}">
      <img class="flag" src="/images/gb.svg" alt=""/>
    </a>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useMainStore } from '@/store'
import { useI18n } from 'vue-i18n'
import { PRINT_CLOUD_STATUS_OPEN, UNIT_PC } from '@/constants'
import axios from 'axios'

const { locale } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define emits
const emit = defineEmits(['showOrderModal'])
// define computed props
const storedLocal = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)
const basket = computed(() => store.print.basket)
const isShopClosed = computed(() => store.tmp.is_exhibition_closed)

const inEnglish = computed(() => {
  return storedLocal.value === 'en'
})

const isCloudStatusOpen = computed(() => {
  return cloud.value.status === PRINT_CLOUD_STATUS_OPEN
})

const articleCount = computed(() => {
  if (basket.value.print_items.length === 0) {
    return 0
  }
  return basket.value.print_items.reduce((a, item) => {
    if (item.unit === UNIT_PC) {
      return a + item.count
    }

    if (parseFloat(item.count) > 0) {
      return a + 1  
    }

    return a
  }, 0)
})
// define watch
watch(() => locale.value, () => {
	selectLocale(locale.value)
})
// define methods
const show = () => {
  emit('showOrderModal')
}

const selectLocale = async (val) => {
	if (storedLocal.value === val) {
		return
	}

	store.settings.locale = val
	await axios.post('/locale', { language: val })
		.then(response => {
      // TODO: update view
    })
		.catch(err => {
			console.error(err)
		});
}
</script>